import React from 'react';
import BeholdWidget from '@behold/react';
import styles from './InstagramFeed.module.css';

const InstagramFeed = () => {
  return (
    <div className={styles.wrapper}>
      <BeholdWidget feedId="vwglrPQRxXpiZTkWyRB4" />
    </div>
  );
};

export default InstagramFeed;
